import React from 'react';
import { NoTranslateProps } from './NoTranslateWrapper.type';

export function NoTranslateWrapper(props: NoTranslateProps) {
  const childNodeWithNoTranlsate = React.useMemo(() => {
    if (typeof props.children === 'string')
      return <span data-notranslate>{props.children}</span>;
    return React.cloneElement(props.children as React.ReactElement, {
      'data-notranslate': true,
    });
  }, [props.children]);

  return childNodeWithNoTranlsate;
}
